import React from "react"
import { Chip, IconButton, FontIcon } from "material-ui"
import autobind from "class-autobind"
import ChooseClientDialogForChip from "./ChooseClientDialogForChip"
import { IClientDocument } from "../../../models"
import strings from "../../../localization/strings"
import * as api from "../../../api"
import _ from "lodash"
import { color } from "echarts"

interface IProps {
    readonly?: boolean
    error?: string
    label: string
    labelColor?: string
    selectedClientIds: string[]
    handleChange(selectedClients: IClientDocument[]): void
}
interface IState {
    loading: boolean
    selectedClients: IClientDocument[]
    openAddClientDialog: boolean
}

export default class MultiClientChips extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            loading: props.selectedClientIds && props.selectedClientIds.length > 0,
            selectedClients: [],
            openAddClientDialog: false,
        }
        autobind(this)
    }

    componentDidMount() {
        this.getSelectedClients(this.props.selectedClientIds)
    }

    componentWillReceiveProps(nextProps: IProps) {
        !_.isEqual(this.props.selectedClientIds, nextProps.selectedClientIds) &&
            this.getSelectedClients(nextProps.selectedClientIds)
    }

    getSelectedClients(clientIds: string[]) {
        clientIds && clientIds.length > 0 ?
            api.getMultiClients(clientIds).then(res =>
                this.setState({
                    loading: false,
                    selectedClients: res.data
                })
            ) :
            this.setState({ loading: false })
    }

    render() {
        return (
            <div>
                <div>
                    <span style={{ color: this.props.labelColor }}>{this.props.label}</span>
                    <span style={{ color: "rgb(244, 67, 54)", fontSize: 12, marginLeft: 15 }}>{this.props.error}</span>
                </div>
                <div style={{ display: "flex", flexWrap: "wrap" }}>
                    {this.state.loading ?
                        <Chip style={{ margin: 5, cursor: "pointer" }}>
                            {strings.loading}
                        </Chip> :
                        this.state.selectedClients.map(client =>
                            <Chip
                                key={client.Id}
                                style={{ margin: 5, cursor: "pointer" }}
                                onRequestDelete={this.props.readonly ?
                                    null :
                                    () => {
                                        const selectedClients = this.state.selectedClients.filter(i => i.Id !== client.Id)
                                        this.setState({ selectedClients })
                                        this.props.handleChange(selectedClients)
                                    }}
                            >
                                {client.Name}
                            </Chip>
                        )
                    }
                    {!this.props.readonly &&
                        <IconButton
                            style={{ height: 35, width: 35, padding: 0, margin: 0, display: "inline-block" }}
                            onTouchTap={() => this.setState({ openAddClientDialog: true })}
                        >
                            <FontIcon className="fa fa-plus-circle" />
                        </IconButton>
                    }
                </div>
                {this.state.openAddClientDialog &&
                    <ChooseClientDialogForChip
                        handleClose={() => this.setState({ openAddClientDialog: false })}
                        handleSave={client => {
                            const selectedClients = this.state.selectedClients
                            !selectedClients.find(i => i.Id === client.Id) &&
                                selectedClients.push(client)
                            this.setState({ selectedClients, openAddClientDialog: false })
                            this.props.handleChange(selectedClients)
                        }}
                    />
                }
            </div>
        )
    }
}